import { ActionWord } from "./action-word";

export class ActionMessageStringHandler {
    static getWasWere(entityType: string) {
        let verb = "was";
        if (
            entityType &&
            entityType.indexOf("s") === entityType.length - 1 &&
            entityType.indexOf("ss") !== entityType.length - 2
        ) {
            verb = "were";
        }
        return verb;
    }

    static getGenericMessageString(entityType: string, actionType: ActionWord, error = false) {
        const verb = ActionMessageStringHandler.getWasWere(entityType);
        return `The ${entityType || "item"} ${verb} ${
            error ? "not" : "successfully"
        } ${actionType}.`;
    }

    static getSpecificErrorMessageString(entityType, error): string {
        let err = error;
        // 409 and 23505 are codes for duplicate keys
        if (typeof error === "object") {
            if (error.code === "23505") {
                const matches = /\((.*?)\)/.exec(error.details);
                let errColumn = "one or more of these values";
                if (matches) {
                    errColumn = "this " + matches[1];
                }
                // add other DB constraint violations here
                err = "A " + entityType + " with " + errColumn + " already exists";
            } else if (error.code === "23503") {
                const matches = /"(.*?)"/.exec(error.details);
                let errTable = "";
                if (matches) {
                    errTable = `(${matches[1]})`;
                }
                err = `Could not delete the ${entityType} because it is used by another resource. ${errTable}`;
            } else if (error.code === -32601) {
                err = `Your controller is missing a feature and needs an update. (${error.message})`;
            }
            // Not connected to RALink
        } else if (
            err &&
            err.indexOf("Post") === 0 &&
            err.indexOf("clarecontrols.com") &&
            err.indexOf("EOF")
        ) {
            err = "The controller is not connected to the ClareCloud server.";
        }

        return err;
    }
}
